<style scoped>
.sub-th {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
}

.th-ellipsis {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.n-ellipsis {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.th-ellipsis:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  width: 100%;
}
.v-data-table-header-mobile {
  display: none !important;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 75px;
  left: 0px;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
</style>

<template>
  <div>
    <div class="mt-n8 mb-3 ml-6" style="font-size: 1.35rem" color="blue">
      <div style="display: flex; justify-content: space-between">
        <div>บทความทั้งหมด</div>
        <div>
          <v-btn color="success" width="100%" @click="insert_article()"
            ><v-icon>mdi-plus</v-icon> เพิ่มบทความ
          </v-btn>
        </div>
      </div>
      <v-divider class="my-3"></v-divider>
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="getIndex"
            :items-per-page="5"
            :loading="tbl_load"
            loading-text="กำลังเรียกข้อมูล..."
            class="elevation-2"
          >
            <template #[`item.CREATE_DATE`]="{ item }">
              <div class="text-truncate" style="max-width: 100px">
                {{ item.CREATE_DATE | filterDate }}
              </div>
            </template>
            <template #[`item.MENU`]="{ item }">
              <!-- <v-btn class="mx-1" text color="default" @click="view_article(item.ID)">
                <v-icon>mdi-magnify</v-icon>
              </v-btn> -->
              <v-btn class="mx-1" text color="default" @click="remove(item.ID)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <!--  <template v-slot:item.HANDI_TYPE="{ item }">
                <div class="text-truncate" style="max-width: 130px">
                  {{ item.HANDI_TYPE }}
                </div>
              </template> -->
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// import XLSX from 'xlsx';
import moment from "moment";
export default {
  name: "RegisterSummary",
  components: {},
  data() {
    return {
      articles: [],
      tbl_load: true,
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "หัวข้อ", value: "HEADER" },
        { text: "วันที่สร้าง", value: "CREATE_DATE" },
        { text: "จัดการ", value: "MENU", align: "center" },
      ],
    
      dateFormatted: null,
      date: null,

    
    };
  },
  created() {
    this.listArticle();
  },
  filters: {
    filterDate(data) {
      return moment(data).add("y", 543).format("DD/MM/YYYY");
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  computed: {
    getIndex() {
      return this.articles.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
    },
  },
  mounted() {},
  methods: {
    listArticle() {
      this.$guest_api
        .get("/list-articles")
        .then((res) => {
          const result2 = res.data.data;
          this.articles = result2;
          this.tbl_load = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    remove(id) {
      this.$swal({
        title: "ต้องการลบข้อมูลหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          // console.log(tbl_data.qt_id);
          this.$token_api
            .delete("/delete-article", {
              data: {
                ID: id,
              },
            })
            .then((response) => {
              this.listArticle();
            })
            .catch((err) => {});
        }
      });
    },
    insert_article() {
      this.$router.push({ path: "/index/insert-article" });
    },
  
  },
};
</script>
